
<label>Server name</label>
<!--
<input type="text" (input)="onUpdateServerName($event)"><br>
{{serverName}}<br>
-->
<input type="text" [(ngModel)]="serverName"><br>
<button class="btn btn-primary" [disabled]="!allowNewServer" (click)="onCreateServer()">Add Server</button>
<p *ngIf="serverCreated; else noServer">Server was created! The name is {{serverName}}</p>

<ng-template #noServer>
    <p>No server was created</p>
</ng-template>